import PenaltyInfoRepositoryImpl from './impl/PenaltyInfoRepositoryImpl'

export default {
  getInstance () {
    return new PenaltyInfoRepositoryImpl()
  }
}
